import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AccessRole, ButtonColumnType, CustomTableComponent, DataColumnType, ICustomTable, LoadingPanelService, LocalService, Page, DATE_WITH_HOUR_FORMAT } from 'lib-base';
import { TramActividadService } from '../../../../services/database/tramActividad.service';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom, forkJoin } from 'rxjs';
import { Router } from '@angular/router';
import { TableLazyLoadEvent } from 'primeng/table';
import { TramiteHistorialActividadComponent } from '../../landing/tramites-historial/tramite-historial-actividad/tramite-historial-actividad.component';
import { IGetMisTramites } from '../../../../shared/interfaces/database/tramite';

@Component({
  selector: 'app-gestionar-actividades-pendientes',
  standalone: true,
  imports: [CustomTableComponent, TramiteHistorialActividadComponent],
  templateUrl: './gestionar-actividades-pendientes.component.html',
  styleUrl: './gestionar-actividades-pendientes.component.scss'
})
export class GestionarActividadesPendientesComponent implements OnInit {
  @Input() tramEstados: string[] = [];
  @Input() tramActividadEstados: string[] = [];
  trans: any = {};
  customTable !: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;
  role = AccessRole;

  constructor(private readonly _ta: TramActividadService, private readonly _t: TranslateService, public ls: LocalService, private readonly _router: Router,
    private readonly _lps: LoadingPanelService
  ) {
  }

  ngOnInit(): void {
    this.translate();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      radicado: this._t.get('common.radicado'),
      tipoDeTrámite: this._t.get('common.tramite'),
      observaciones: this._t.get('common.observaciones'),
      estado: this._t.get('common.estado'),
      fechaActualización: this._t.get('common.fechaActualización'),
      fechaSolicitud: this._t.get('common.fechaSolicitud'),
      dependencia: this._t.get('common.dependencia'),
      usuarioAsignado: this._t.get('common.usuarioAsignado'),
      semaforoDeCumplimiento: this._t.get('common.semaforoDeCumplimiento'),
    }));
    this.configurarTabla();
  }

  configurarTabla(): void {
    const indicadorActivo: boolean = this.tramEstados.includes('ACTIVO');
    this.customTable = {
      caption:{
        globalFilter:{
          placeholder: this.trans.usuarioAsignado + '...'
        }
      },
      header:{},
      columns: [
        {
          field: 'expand',
          header: '',
          class:'p-button-info',
          width: '0.5rem',
          buttonType: ButtonColumnType.EXPANDED
        },
        {
          field: 'tiposTramiteDescripcion',
          header: this.trans.tipoDeTrámite,
          class:'font-13',
          width: '22em',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          sort: true,
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'dependencia',
          header: this.trans.dependencia,
          sort: true,
          width: '17rem',
          class:'brand-table-tag mx-auto my-auto font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'radicado',
          header: this.trans.radicado,
          sort: true,
          columnFilter: true,
          dataType: DataColumnType.NUMBER,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
        },
        {
          field: 'observaciones',
          class:'font-13',
          width: "15em",
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          header: this.trans.observaciones,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'tramiteEstado',
          header: this.trans.estado,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          dataType: DataColumnType.ESTADO_TAG
        },
        {
          field: indicadorActivo ? 'rangoIndicadorInicial' : 'rangoIndicadorFinal',
          header: this.trans.semaforoDeCumplimiento,
          sort: true,
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
          },
          columnFilter: true,
          dataType: DataColumnType.TAG,
          getStyle: (data: IGetMisTramites) => {
            const color = data.tramiteEstado === 'ACTIVO' ? data.rangoColorInicial : data.rangoColorFinal;
            return {
              'background-color': color
            };
          }
        },
        {
          field: 'fechaActualizacion',
          header:  this.trans.fechaActualización,
          sort: true,
          width: "5em",
          class:'font-12',
          columnmHeader: {
            class:'text-left color-blue-2 font-12 font-bold',
            style:{'text-wrap': 'auto'}
          },
          format:DATE_WITH_HOUR_FORMAT,
          dataType: DataColumnType.DATE,
        },
        {
          field: 'fechaSolicitud',
          header: this.trans.fechaSolicitud,
          sort: true,
          width: "5em",
          class:'font-12',
          columnmHeader: {
            class:'text-left color-blue-2 font-12 font-bold',
            style:{'text-wrap': 'auto'}
          },
          format:DATE_WITH_HOUR_FORMAT,
          dataType: DataColumnType.DATE,
        },
      ],
      settings: {
        table: {
          rows: 8,
          lazy: true
        }
      }
    } as ICustomTable;
  }

  lazyloadRecords(event: TableLazyLoadEvent) {
    this.getMisTramitesByDependencia(event);
  }

  getMisTramitesByDependencia(event?: TableLazyLoadEvent){
    this._lps.show(true);
    this._ta.getMisTramitesByDependencia(this.tramEstados, this.tramActividadEstados, event).subscribe({
      next: (data: Page<IGetMisTramites>) => {
        this._lps.hide();
        this.customTableComponent.data = data.content;
        this.customTableComponent.totalRecords = data.totalElements;
      }
    });
  }
}
